import {
  Directive,
  HostBinding,
  ElementRef,
  Renderer2,
  AfterViewInit,
} from '@angular/core';

@Directive({
  selector: '[appDisableAutofill], form, input, textarea',
})
export class DisableAutofillDirective {
  private randomString = `${new Date().getTime()}`;

  // @HostBinding('attr.name') name = this.randomString;
  // @HostBinding('attr.autocomplete') autocomplete = 'new-' + this.randomString;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    const el = this.el.nativeElement;
    const tagName = el.tagName.toLowerCase();

    // Inject hidden dummy inputs if it's a form
    if (tagName === 'form') {
      this.injectDummyFields(el);
    }

    // Apply autocomplete + name after slight delay to avoid autofill timing
    if (
      (tagName === 'input' && el.type !== 'radio') ||
      tagName === 'textarea'
    ) {
      setTimeout(() => {
        // Only override name if not already set
        if (!el.getAttribute('name')) {
          this.renderer.setAttribute(el, 'name', this.randomString);
        }

        // Set a randomized autocomplete value
        this.renderer.setAttribute(
          el,
          'autocomplete',
          'new-' + this.randomString
        );
      }, 500);
    }
  }

  private injectDummyFields(form: HTMLElement) {
    const dummyUser = this.renderer.createElement('input');
    this.renderer.setAttribute(dummyUser, 'type', 'text');
    this.renderer.setAttribute(dummyUser, 'name', 'fake_user');
    this.renderer.setAttribute(dummyUser, 'autocomplete', 'username');
    this.setHiddenStyle(dummyUser);

    const dummyPass = this.renderer.createElement('input');
    this.renderer.setAttribute(dummyPass, 'type', 'password');
    this.renderer.setAttribute(dummyPass, 'name', 'fake_pass');
    this.renderer.setAttribute(dummyPass, 'autocomplete', 'current-password');
    this.setHiddenStyle(dummyPass);

    // Insert dummy fields at top of form
    this.renderer.insertBefore(form, dummyUser, form.firstChild);
    this.renderer.insertBefore(form, dummyPass, form.firstChild);
  }

  private setHiddenStyle(el: HTMLElement) {
    this.renderer.setStyle(el, 'position', 'absolute');
    this.renderer.setStyle(el, 'opacity', '0');
    this.renderer.setStyle(el, 'height', '0');
    this.renderer.setStyle(el, 'width', '0');
    this.renderer.setStyle(el, 'border', '0');
    this.renderer.setStyle(el, 'padding', '0');
    this.renderer.setStyle(el, 'margin', '0');
    this.renderer.setAttribute(el, 'tabindex', '-1');
    this.renderer.setAttribute(el, 'aria-hidden', 'true');
  }
}
